import styled from "styled-components";
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
    background-color: #101522;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

export const FooterWrap = styled.div`
    padding: 64px 32px 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;

    @media screen and (max-width: 768px) {
        padding: 48px 24px 36px;
    }

    @media screen and (max-width: 480px) {
        padding: 40px 20px 32px;
    }
`;

export const FooterLinksContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 40px;

    @media screen and (max-width: 820px) {
        padding-top: 32px;
        margin-bottom: 32px;
    }
`;

export const FooterLinksWrapper = styled.div`
    display: flex;

    @media screen and (max-width: 820px) {
        flex-direction: column;
    }
`;

export const FooterLinkItems = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 16px 24px;
    text-align: left;
    width: 160px;
    box-sizing: border-box;
    color: #fff;

    @media screen and (max-width: 420px) {
        margin: 0;
        padding: 10px;
        width: 100%;
        align-items: center;
        text-align: center;
    }
`;

export const FooterLinkTitle = styled.h1`
    font-size: 15px;
    margin-bottom: 20px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: rgba(255, 255, 255, 0.9);
`;

export const FooterLink = styled(Link)`
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    margin-bottom: 8px;
    font-size: 14px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.2px;

    &:hover {
        color: #38A7BA;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        transform: translateX(2px);
    }
`;

export const SocialMedia = styled.section`
    max-width: 1000px;
    width: 100%;
`;

export const SocialMediaWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1100px;
    margin: 40px auto 0 auto;
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);

    @media screen and (max-width: 820px) {
        flex-direction: column;
        gap: 20px;
    }
`;

export const SocialLogo = styled(Link)`
    color: #fff;
    justify-self: start;
    cursor: pointer;
    text-decoration: none;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-weight: bold;
`;

export const WebsiteRights = styled.small`
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 16px;
    font-size: 14px;
    letter-spacing: 0.2px;
`;

export const SocialIcons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 240px;
`;

export const SocialIconLink = styled.a`
    color: rgba(255, 255, 255, 0.7);
    font-size: 24px;
    margin: 0 12px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 50%;
    padding: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: #38A7BA;
        background: rgba(56, 167, 186, 0.1);
        transform: translateY(-2px);
    }
`;

export const Imgs = styled.embed`
    width: 14vw;
    height: auto;

    @media screen and (max-width: 768px){
        width: 25vw;
        height: auto;
    }
    
    @media screen and (max-width: 490px){
        width: 37vw;
        height: auto;
    }

    @media screen and (max-width: 280px){
        width: 42vw;
        height: auto;
    }
`;